import { Color, Keyword } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/outline-color}
 * @internal
 */
export default Longhand.of(Keyword.of("invert"), Color.parse, (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=outline-color.js.map